var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOpSymbolikuvitus128002(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-128-002-1{fill:#fff;}.cls-128-002-2,.cls-128-002-3,.cls-128-002-5{fill:none;}.cls-128-002-2,.cls-128-002-3{stroke:#6e6e6e;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.25px;}.cls-128-002-3{fill-rule:evenodd;}.cls-128-002-4{fill:#969696;}.cls-128-002-5{opacity:0.2;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-128-002-1",
    width: 128,
    height: 128
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-128-002-2",
    points: "73.37 34.87 76.67 32.73 76.67 41.19"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-128-002-2",
    cx: 68.71,
    cy: 57.92,
    r: 6.84
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-128-002-3",
    d: "M66.8,36.37a9.1,9.1,0,1,1,2.12,6.68"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-128-002-2",
    d: "M78.9,28.14c-.85-2.08-2-4.6-3-6.58C74,18,72.22,15.46,68.65,14.22L48.8,9.81a9.69,9.69,0,0,0-4.44.4L23.63,19.86l-5.08.07"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-128-002-2",
    d: "M18.55,38.16c1.91.39,4.29.9,6.54,1.46C30,40.85,36.16,45.09,42.19,46s31.43-.41,30-7c-.51-2.32-2.55-2.56-4.45-2.42-.4,0-19,4.36-20.25-4.34-1-7.22,3.86-9.1,10-9.48,5.59-.34,10,.69,13.14,5.91.06.09.2.39.39.79"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-128-002-2",
    x: 9.56,
    y: 17.24,
    width: 8.99,
    height: 23.45
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-128-002-2",
    d: "M29.8,69.82c-3.91,3-3.75,8.78-3.75,8.78s5.19,1.86,9.44-1.43,3.75-8.78,3.75-8.78S33.93,66.62,29.8,69.82Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-128-002-2",
    x1: 32.07,
    y1: 74.08,
    x2: 26.05,
    y2: 78.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-128-002-2",
    d: "M22.3,69.82c3.91,3,3.75,8.78,3.75,8.78s-5.19,1.86-9.44-1.43-3.75-8.78-3.75-8.78S18.17,66.62,22.3,69.82Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-128-002-2",
    x1: 20.03,
    y1: 74.08,
    x2: 26.05,
    y2: 78.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-128-002-2",
    d: "M21.44,61c0,4.93,4.67,8.31,4.67,8.31s4.64-3,4.62-8.34-4.67-8.32-4.67-8.32S21.42,55.81,21.44,61Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-128-002-2",
    x1: 26.05,
    y1: 62.5,
    x2: 26.05,
    y2: 84.58
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-128-002-2",
    points: "31.27 98.27 20.83 98.27 18.71 84.58 33.38 84.58 31.27 98.27"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-128-002-2",
    d: "M16.8,103.14h6a4.55,4.55,0,0,1,4.55,4.55v6a4.55,4.55,0,0,1-4.55,4.55H12.25a0,0,0,0,1,0,0V107.69A4.55,4.55,0,0,1,16.8,103.14Z"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-128-002-2",
    points: "20.57 118.27 35.85 118.27 38.66 118.27 38.66 111.36 35.85 111.36 35.85 114.5 27.38 114.5"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-128-002-2",
    cx: 19.81,
    cy: 110.7,
    r: 3.53
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-128-002-4",
    cx: 73.1,
    cy: 88.61,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-128-002-4",
    cx: 60.47,
    cy: 88.61,
    r: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-128-002-2",
    d: "M50,101.88V80.34a5.12,5.12,0,0,1,5.22-5H78.39a5.12,5.12,0,0,1,5.23,5v21.54"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-128-002-2",
    points: "83.62 95.93 83.62 101.93 49.95 101.93 49.95 95.93"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-128-002-2",
    d: "M50,95.93h0a6,6,0,1,0-6,6c.19,0,.38,0,.56,0l1.12,8.1h42.3l1.12-8.1c.19,0,.37,0,.56,0a6,6,0,1,0-6-6h0"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-128-002-2",
    points: "55.26 109.97 51.91 118.27 49.03 118.27 50.15 109.97"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-128-002-2",
    points: "78.3 109.97 81.66 118.27 84.53 118.27 83.41 109.97"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-128-002-2",
    d: "M117.66,56.71h-24V71.3h0v8.94a1.25,1.25,0,0,0,1.26,1.26h8.39l-3.6,30.77a6,6,0,1,0,12,0L108.07,81.5h8.34a1.25,1.25,0,0,0,1.25-1.26V75.48h0Zm-12,57.46a2.38,2.38,0,1,1,2.38-2.38A2.39,2.39,0,0,1,105.66,114.17Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-128-002-2",
    x1: 97.35,
    y1: 57.06,
    x2: 97.35,
    y2: 67.34
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-128-002-2",
    x1: 114,
    y1: 57.06,
    x2: 114,
    y2: 62.76
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-128-002-2",
    x1: 109.84,
    y1: 57.06,
    x2: 109.84,
    y2: 64.37
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-128-002-2",
    x1: 105.68,
    y1: 57.06,
    x2: 105.68,
    y2: 66.09
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-128-002-2",
    x1: 101.51,
    y1: 57.06,
    x2: 101.51,
    y2: 63.86
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-128-002-2",
    x1: 93.61,
    y1: 71.3,
    x2: 117.66,
    y2: 71.3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-128-002-5",
    width: 128,
    height: 128
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpSymbolikuvitus128002);
export default __webpack_public_path__ + "static/media/OP_symbolikuvitus_128_002.6cb359064df423ef93730aa92cec4c9e.svg";
export { ForwardRef as ReactComponent };